import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { formUpdate } from './registration-form-actions';
import type { FormUpdate, State } from './registration-form-types';

export const initialState: State = {
  isSubmitted: false,
  isValid: null,
  answers: null,
};

const registrationFormSlice = createSlice({
  name: 'registrationForm',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      formUpdate.type,
      (state, { payload }: PayloadAction<FormUpdate>) => {
        state.isSubmitted = payload.isSubmitted;
        state.answers = payload.answers;
        state.isValid = payload.isValid;
      },
    );
  },
});

export const { reducer } = registrationFormSlice;
